import ErrorHelper from '../helpers/errorHelper';
import {StoreSavedPreset} from '../typescript/storeTypes';
import AuthorizedRequest from './authorizedRequests';


export default class PresetApi {
    static getPresets(location: string): Promise<StoreSavedPreset[]> {
        return AuthorizedRequest.getAuthorizedRequest(`presets?location=${encodeURIComponent(location)}`)
            .ok(res => res.status === 200)
            .then(response => (response.body || []).map((p: any): StoreSavedPreset => ({
                location: p.location ?? p.Location,
                name: p.name ?? p.Name,
                data: p.data ?? p.Data
            })))
            .catch(ErrorHelper.getCustomWebsiteErrorFunction());
    }

    static savePreset(preset: StoreSavedPreset): Promise<any> {
        return AuthorizedRequest.postAuthorizedRequest('presets', {
            location: preset.location,
            name: preset.name,
            data: preset.data
        })
            .ok(res => res.status === 200)
            .catch(ErrorHelper.getCustomWebsiteErrorFunction());
    }

    static deletePreset(location: string, name: string): Promise<any> {
        return AuthorizedRequest.deleteAuthorizedRequest(
            `presets?location=${encodeURIComponent(location)}&name=${encodeURIComponent(name)}`)
            .ok(res => res.status === 200)
            .catch(ErrorHelper.getCustomWebsiteErrorFunction());
    }
}
